import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import config from '@/utils/config';
import { STORAGE } from '@/constants/storage.constant';

type AuthState = {
  authToken: string | null;
};

type AuthActions = {
  logout: () => void;
  setAuthToken: (authToken: AuthState['authToken']) => void;
};

type AuthStore = AuthState & AuthActions;

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      authToken: null,
      isAuthenticated: false,
      logout: () => set({ authToken: null }),
      setAuthToken: (authToken) => set({ authToken }),
    }),
    {
      name: STORAGE.USER_SESSION,
      version: config.version,
    },
  ),
);
